import * as React from 'react';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        'w-full rounded-[7px] border border-s-line2 bg-[#f6f8f7] px-[13px] py-[11px] text-[13px] text-s-text outline-none transition-colors placeholder:text-s-dim focus-visible:border-s-accent focus-visible:ring-1 focus-visible:ring-s-accent disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export { Input };
